export default __webpack_public_path__ + "static/estimator-converse-c4b895a0cd5534e970f468ca2b32bc63.svg";